<template>
  <section id="formsButton" class="container mx-auto">
    <!-- Codigo de descarga -->
    <div id="formFolio" class="w-full md:w-2/5 mt-4 mx-auto px-4 md:px-0 md:min-w-124">
      <div class="title uppercase text-center font-bold">
        {{ $t("Forms.login_account") }}
      </div>
      <p class="text-sm mt-3 mb-3 text-center">
        {{ $t("Forms.login_message") }}
      </p>

      <LoginForm />

      <p class="py-3 text-center">
        <a @click.prevent="loggedProcess" class="font-semibold underline cursor-pointer text-newxcaret-blue">
          {{ $t("Forms.login_guest") }}
        </a>
      </p>
    </div>
  </section>
</template>

<script>
import "../validators/index";

import AlbumsMix from "../mixins/albums/GetAlbumsByEmail";
import LoginForm from "../forms/login.vue";

export default {
  props: [],
  mixins: [AlbumsMix],
  components: { LoginForm },
  data: () => ({
    form: {
      email: "",
    },
  }),
  computed: {},
  methods: {
    /**
     * @description Submit the form
    */
    async submit() {
      await this.loggedProcess();
    },
    /**
     * @description Set the user as logged by email
     */
    async loggedProcess() {
      this.$store.dispatch("setAuthGuest");
    },
  },
  created() {},
  mounted() {},
};
</script>
